<template>
    <div class="row m-0 p-2 col-12 justify-content-between">
        <div
            class="d-flex align-items-center justify-content-between col-12 p-2 m-0 bg-secondary2"
            align-items-center
        >
            <div class="row m-0 p-0 col-auto align-items-center">
                <i class="fa fa-home" role="button" @click="goHome"></i>
                <template v-if="!user">
                    <template v-for="(dir, i) in stack" :key="dir">
                        <i class="fa fa-angle-right px-2"></i>
                        <label
                            role="button"
                            class="m-0 p-0"
                            @click="() => goDir(i)"
                            >{{ dir }}</label
                        >
                    </template>
                </template>
                <template v-else>
                    <i class="fa fa-angle-right px-2"></i>
                    <i class="fa fa-user-circle"></i>
                    <i class="fa fa-angle-right px-2"></i>
                    <label
                        role="button"
                        class="m-0 p-0"
                        @click="getUserFiles"
                        >{{ user.name }}</label
                    >
                </template>
            </div>

            <div class="row m-0 p-0 col-auto">
                <button
                    @click="showFindUser = true"
                    class="btn btn-primary mx-2"
                >
                    <i class="fa fa-user"></i>
                </button>
                <button
                    v-if="!user"
                    @click="newFolder = true"
                    class="btn btn-primary mx-2"
                >
                    <i class="fa fa-folder-plus"></i>
                </button>

                <button @click="show = true" class="btn btn-primary mx-2">
                    <i class="fa fa-plus"></i>
                </button>

                <button
                    class="btn btn-danger mx-2"
                    @click="remove"
                    :disabled="Object.keys(selected).length < 1"
                >
                    <i class="fa fa-trash"></i>
                </button>
            </div>
        </div>

        <div
            class="row flex-wrap m-0 p-2 col-12"
            :class="{
                'justify-content-evenly': files.length >= 1,
                'justify-content-center': files.length < 1,
            }"
        >
            <div
                v-if="files.length < 1"
                class="p-2 file-container text-center col-4 col-md-3 col-lg-2"
            >
                <i
                    class="fa fa-image text-secondary"
                    style="font-size: 10rem !important"
                ></i>
                <div class="col-12 small p-0 m-0 text-center text-uppercase">
                    {{ t("my-gifs.empty") }}
                </div>
            </div>
            <div
                role="button"
                v-for="({ type, name, path, url }, i) in files"
                :key="i"
                class="p-2 file-container col-4 col-md-3 col-lg-2"
                :class="{ 'bg-danger': selected[path] }"
            >
                <template v-if="!user">
                    <img
                        :src="type == 'dir' ? folderIcon : getFullPath(path)"
                        class="col-12 img"
                        @click="
                            () => {
                                (type == 'dir' ? go : select)(path);
                            }
                        "
                    />
                    <div
                        class="col-12 small p-0 m-0 text-center text-capitalize"
                        @click="
                            () => {
                                (type == 'dir' ? go : select)(path);
                            }
                        "
                    >
                        {{ name }}
                    </div>
                    <i
                        v-if="type == 'dir'"
                        @click="() => removePath(path)"
                        role="button"
                        class="fa fa-trash-alt text-danger hover-icon position-absolute"
                    ></i>
                </template>
                <template v-else>
                    <img
                        :src="url"
                        class="col-12 img"
                        @click="
                            () => {
                                select(path);
                            }
                        "
                    />
                    <div
                        class="col-12 small p-0 m-0 text-center text-capitalize"
                        @click="
                            () => {
                                select(path);
                            }
                        "
                    >
                        {{ name }}
                    </div>
                </template>
            </div>
        </div>

        <modal-component
            @hide="() => (this.newFolder = false)"
            :show="newFolder"
            :classList="['col-10 col-md-7 col-lg-5']"
            :title="t('new.newfolder')"
        >
            <form @submit.prevent="makeDir" class="p-2">
                <label for="foldername">{{ t("new.foldername") }}</label>
                <input
                    required
                    class="form-control"
                    type="text"
                    id="foldername"
                    name="foldername"
                    v-model="folderName"
                    :placeholder="t('new.foldername')"
                />

                <button type="submit" class="btn btn-success my-2">
                    {{ t("treinos.create") }}
                </button>
            </form>
        </modal-component>

        <modal-component
            @hide="showFindUser = false"
            show
            :classList="['col-10 col-md-7 col-lg-5']"
            :title="t('my-gifs.admin.form-title')"
            v-if="showFindUser"
        >
            <form @submit.prevent="getUserFiles" class="p-2">
                <label for="email">{{ t("auth.login.email") }}</label>
                <input
                    required
                    class="form-control"
                    type="email"
                    id="email"
                    name="email"
                    v-model="userEmail"
                    :placeholder="t('auth.login.email')"
                />

                <button type="submit" class="btn btn-success my-2">
                    {{ t("my-gifs.admin.find") }}
                </button>
            </form>
        </modal-component>

        <modal-component
            @hide="() => (this.show = false)"
            :show="show"
            :classList="['col-11 col-lg-10']"
            :title="t('files.add')"
        >
            <div class="row col-12 m-0 p-1">
                <button
                    class="btn btn-outline-primary mx-1"
                    @click="clickSelect"
                >
                    <i class="fa fa-plus-circle"></i> {{ t("new.addfiles") }}
                </button>
                <button class="btn btn-outline-danger mx-1" @click="cleanFiles">
                    <i class="fa fa-trash-alt"></i> {{ t("new.cleanfiles") }}
                </button>
            </div>
            <form @submit.prevent="send">
                <div class="col-12 p-2">
                    <input
                        type="file"
                        @change="addFiles"
                        multiple
                        ref="fileinput"
                        class="d-none"
                    />
                    <div class="row p-1 m-0 col-12">
                        <div
                            v-for="(image, i) in images"
                            :key="i"
                            class="file-container p-2 col-6 col-md-4 col-lg-3 position-relative"
                        >
                            <img
                                :src="getObjectUrl(image.file)"
                                class="col-12 img"
                            />
                            <input
                                type="text"
                                class="form-control"
                                required
                                v-model="image.name"
                                placeholder="Nome do ficheiro"
                            />
                            <i
                                @click="() => removeFile(i)"
                                role="button"
                                class="fa fa-trash-alt text-danger hover-icon position-absolute"
                            ></i>
                        </div>
                    </div>

                    <button
                        v-if="images.length > 0"
                        type="submit"
                        class="btn btn-success my-2"
                    >
                        Enviar
                    </button>
                </div>
            </form>
        </modal-component>
    </div>
</template>

<script>
import Api from "@/utilities/Api";
import { mapActions, mapMutations } from "vuex";
import folderIcon from "../../assets/icons/folder.svg";
import { t } from "../../lang/index.js";
import ModalComponent from "@/components/AdminLTE/Components/ModalComponent.vue";
import { getExImage } from "@/utilities/HelpFunctions.js";

export default {
    name: "FilesView",
    data() {
        return {
            path: "",
            files: [],
            folderIcon,
            selected: {},
            images: [],
            show: false,
            newFolder: false,
            folderName: "Nova pasta",
            showFindUser: false,
            userEmail: "",
            user: null,
        };
    },
    created() {
        document.title = "Gifs";
        this.goHome();
    },
    components: {
        ModalComponent,
    },
    methods: {
        ...mapMutations(["SET_LOADING"]),
        ...mapActions(["get", "post", "delete"]),
        t,
        getFullPath(path) {
            return `${Api.url}images/GIFS/${path}`;
        },
        select(image) {
            if (this.selected[image]) {
                delete this.selected[image];
            } else {
                this.selected[image] = true;
            }
        },
        go(dir) {
            this.path = dir;
            this.selected = {};
            this.getPath(dir);
        },
        goHome() {
            this.go("");
        },
        goDir(index) {
            let fullPath = "";
            this.selected = {};
            for (let i = 0; i <= index; i++) {
                fullPath += this.stack[i] + "/";
            }

            console.log("Go to dir: ", this.stack[index], "Full: ", fullPath);
            this.go(fullPath);
        },

        async getPath(path = "") {
            this.SET_LOADING(true);
            this.files = [];
            this.user = null;

            try {
                const { data } = await this.get({
                    url: "admin/gifs?path=" + path,
                });
                this.files = data.files;
                console.log(data);
            } catch (e) {
                alert("Ocorreu um erro buscando os arquivos");
                console.log(e);
            } finally {
                this.SET_LOADING(false);
            }
        },

        async remove() {
            const formData = new URLSearchParams();
            const images = Object.keys(this.selected);

            if (images.length < 1 || !confirm(this.t("general.do-you-want"))) {
                return;
            }
            for (let i = 0; i < images.length; i++) {
                formData.append(`paths[${i}]`, images[i]);
            }

            this.SET_LOADING(true);
            console.log(formData.toString());

            const prefix = this.user ? "users-" : "";
            const res = await this.delete({
                url: `admin/${prefix}gifs?${formData.toString()}`,
            });

            if (res.status >= 200 && res.status < 300) {
                if (!this.user) {
                    this.go(this.path);
                } else {
                    this.getUserFiles();
                }
                alert(this.t("general.deleted"));
            } else {
                console.log(res);
                alert("Erro");
            }
            this.SET_LOADING(false);
        },

        removeFile(index) {
            this.images.splice(index, 1);
        },

        addFiles(event) {
            console.log(event.target.files);
            if (event.target && event.target.files) {
                const files = event.target.files;
                if (files.length > 0) {
                    for (const file of files) {
                        const extension = file.name.split(".").pop();
                        if (!["webp", "gif"].includes(extension)) {
                            alert(t("new.onlygifs"));
                            continue;
                        }
                        const baseName = file.name.substring(
                            0,
                            file.name.lastIndexOf("."),
                        );
                        this.images.push({ name: baseName, file: file });
                    }
                }
            }
        },

        getObjectUrl(blob) {
            return URL.createObjectURL(blob);
        },

        async send() {
            if (this.images.length > 0) {
                this.SET_LOADING(true);
                const formData = new FormData();

                formData.append(
                    "path",
                    this.user ? `user_${this.user.id}` : this.path,
                );
                for (const image of this.images) {
                    formData.append(`images[${image.name}]`, image.file);
                    console.log(image);
                }

                const prefix = this.user ? "users-" : "";
                const res = await this.post({
                    url: `admin/${prefix}gifs`,
                    formData: true,
                    data: formData,
                });

                if (res.status >= 200 && res.status < 300) {
                    alert(t("files.added"));
                    this.images = [];
                    this.show = false;
                } else {
                    alert("Error\n\n" + res.data?.message);
                }

                console.log(res);
                if (!this.user) {
                    this.go(this.path);
                } else {
                    this.getUserFiles();
                }
                // this.SET_LOADING(false)
            } else {
                return;
            }
        },

        clickSelect() {
            this.$refs.fileinput.click();
        },
        cleanFiles() {
            this.images = [];
        },

        async makeDir() {
            this.SET_LOADING(true);

            const res = await this.post({
                url: "admin/gifs/mkdir",
                formData: false,
                data: {
                    name: this.folderName,
                    path: this.path,
                },
            });

            console.log(res);
            if (res.status >= 200 && res.status < 300) {
                this.go(this.path);
                alert(t("new.foldercreated"));
            } else {
                alert("Error\n\n" + res.data?.message);
            }
            this.newFolder = false;
            this.SET_LOADING(false);
        },

        async removePath(path) {
            if (confirm(t("general.do-you-want"))) {
                this.SET_LOADING(true);

                const res = await this.delete({
                    url: `admin/gifs?paths[0]=${path}`,
                });

                if (res.status >= 200 && res.status < 300) {
                    if (!this.user) {
                        this.go(this.path);
                    } else {
                        this.getUserFiles();
                    }
                    alert(this.t("general.deleted"));
                } else {
                    console.log(res);
                    alert("Erro\n\n" + res.data?.message);
                }
                this.SET_LOADING(false);
            }
        },

        // Gifs de usuarios
        async getUserFiles() {
            this.selected = {};
            this.SET_LOADING(true);
            const email = this.userEmail;
            const res = await this.get({
                url: `admin/users-gifs?email=${email}`,
            });
            console.log(res);
            if (res.status == 404) {
                alert("Nao foi encontrado nenhum usuario com o email " + email);
            } else if (res.status != 200) {
                alert("erro \n\n" + res.data.message);
            } else {
                // okay
                this.user = res.data.user;
                this.files = [];
                const gets = res.data.files.map(async (file) => {
                    return new Promise((resolve) => {
                        const path = `user_${this.user.id}/${file}`;
                        getExImage(
                            "",
                            this.get,
                            `admin/users-gifs/download?path=${path}`,
                            "image/gif",
                        )
                            .then((url) => {
                                this.files.push({
                                    type: "gif",
                                    url,
                                    path,
                                    name: file,
                                });
                            })
                            .finally(resolve);
                    });
                });
                await Promise.all(gets);
                this.showFindUser = false;
            }
            this.SET_LOADING(false);
        },
    },

    computed: {
        stack() {
            console.log(
                this.path.split("/").filter((value) => value.length > 0),
            );
            return this.path.split("/").filter((value) => value.length > 0);
        },
    },
};
</script>

<style scoped lang="scss">
.file-container {
    transition: all 0.3s ease-in-out;
    border-radius: 7px;

    .img {
        aspect-ratio: 1 / 1; /* Define a proporção 1:1 (quadrado) */
        object-fit: contain;
    }
}
</style>
